// extracted by mini-css-extract-plugin
module.exports = {"checkboxCard":"loading-goods-modal_checkboxCard__Ioi1D"};